import React from "react";
import { appStyles } from "../../../utils/appStyle";
import Block from "../../../component/block";
import mixpanel from "mixpanel-browser";
import { logContentBlockPressEvent } from "../../../utils/events";
import { useAppContext } from './.././../../util'

// render LinkToPage component
const LinkToPage = ({
  selectedPageId,
  buttonText,
  icon,
  highlight,
  color,
  index,
  contentBlockId,
}) => {

  const { userId, pageId } = useAppContext()

  const handleLinkedPage = () => {
    logContentBlockPressEvent(contentBlockId);
    mixpanel.track("Web Link Clicked", {
      Button_type: "linkedpage",
      distinct_id: userId,
      stack_id: pageId,
    });
    window.location.assign(selectedPageId);
  };

  const STYLES = appStyles(color, highlight);

  return (
    <div
      key={index}
      style={{
        marginTop: "8px",
        borderRadius: STYLES.borderRadius,
        border: STYLES.border,
        background: STYLES.background,
      }}
    >
      <div
        style={{
          display: "flex",
          padding: "15px",
          justifyContent: "space-between",
          alignItems: "center",
          color: STYLES.Color,
          cursor: "pointer",
        }}
        onClick={handleLinkedPage}
      >
        <Block
          icon={icon}
          content={buttonText}
          rightIcon="fa-sharp fa-solid fa-chevron-right"
        />
      </div>
    </div>
  );
};

// export component LinkToPage
export default LinkToPage;
